import axios from 'axios';
import API from '@/services/API.js';
import Globals from '@/services/globals.js';
import {EventBus} from '@/components/dashboard/eventbus/EventBus';
import Utils from '@/services/utils.js'

class Source {
    constructor(url, delay, refresh = true) {
        this.interval = null;
        this.url = url;
        this.delay = delay;
        this.refresh = refresh;
        this.name = this.sourceNameFromURL();
        this.page = 1;
        this.perpage = 999999;
        this.query = null;
        this.init();
    }
    init() {
        if(this.name == 'Datis'){
            if(!Utils.can('beepiz-select-devices')){
                return
            }
            this.perpage = 11;
        }
        if(this.name == 'Events'){
            if(!Utils.can('beepiz-browse-events')){
                return
            }
        }
        this.constructURL();
          if (this.refresh) {
            this.interval = setInterval(() => {
              this.loadData();
            }, this.delay);
          }
        this.loadData();
    }
    loadData() {
        axios.get(this.url + '?perpage=' + this.perpage + '&page=' + this.page + '&query=' + this.query)
            .then(response => {

                var event = {
                    source: this.name,
                    data: response.data.data,
                    meta: response.data.meta
                }
                EventBus.$emit('source-ready', event);
            })
    }
    constructURL() {
        if (this.url.indexOf('http') == -1) {
            this.url = API.apiBaseURL + this.url;
        }
    }
    sourceNameFromURL() {
        var tabSourcesName = {
            'dati': 'Datis',
            'event': 'Events'
        }
        for (var sKey in tabSourcesName) {
            if (this.url.indexOf(sKey) != -1) {
                return tabSourcesName[sKey];
            }
        }
        return null;
    }
    destroy() {
        clearInterval(this.interval);
    }
}

export default Source;
